import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  resourceStorages: [{}],
  resourceStorage: {},
  newResourceStorage: {},
  deletedResourceStorage: {},
  error: null,
};

const resourceStorageSlice = createSlice({
  name: 'resourceStorage',
  initialState,
  reducers: {
    setReducerError: (state, action) => {
      state.error = action.error;
    },
    setResourceStorages: (state, action) => {
      state.resourceStorages = action.payload;
      state.error = null;
    },
    setResourceStorage: (state, action) => {
      state.resourceStorage = action.payload;
      state.error = null;
    },
    setNewResourceStorage: (state, action) => {
      state.newResourceStorage = action.payload;
      state.error = null;
    },
    setDeletedResourceStorage: (state, action) => {
      state.deletedResourceStorage = action.payload;
      state.error = null;
    },
    setResetResourcesStorage: () => {
      return initialState;
    },
  },
});

export const {
  setReducerError,
  setResourceStorages,
  setResourceStorage,
  setNewResourceStorage,
  setDeletedResourceStorage,
  setResetResourcesStorage,
} = resourceStorageSlice.actions;

export default resourceStorageSlice.reducer;
